export const replacePlaceholders = (text, infoUsers, contactId) => {
  const substitutions = {
    SOCIALNAME: contactId.cliente ? contactId.cliente : "",
    NOMEAGENTE: infoUsers.displayname ? infoUsers.displayname : "",
    PROTOCOLO: contactId.protocolo ? contactId.protocolo : "",
    CDRID: contactId.idatendimento ? contactId.idatendimento : "",
    ATDID: contactId.serviceatd ? contactId.serviceatd : "",
    LOGINAGENTE: infoUsers.email ? infoUsers.email : "",
    NUMEROCLIENTE: contactId.telefone ? contactId.telefone : "",
  };

  const hasText = !!text;
  if (hasText) {
    return text.replace(/\$\{SYS\.(.*?)\}/g, (_, chave) => {
      return substitutions[chave] || ``;
    });
  }

  return text;
};
